import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TimePicker from "react-bootstrap-time-picker";
import { API_URL } from "../../../../constants";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { Modal } from "react-bootstrap";

const Shift = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [Shift, setShift] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [weekdays, setweekdays] = useState([]);
  const [weekShift, setWeekshift] = useState([]);
  const [status, setStatus] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rowToDeleteIndex, setRowToDeleteIndex] = useState(null);

  const [formData, setFormData] = useState({
    Name: "",
    Code: "",
    Description: "",
    FromTime: "07:00:00",
    ToTime: "19:00:00",
    Hrs: "12",
    lines: [
      {
        ShiftID: "",
        LineNo: 1,
        Day_046: "",
        Week_049: "",
        AttendanceStatusID: "",
      },
    ],
  });

  const columns = {
    Code: { text: "Code", align: "start", visible: true },
    Name: { text: "Name", align: "start", visible: true },
    Description: { text: "Description", align: "start", visible: true },
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Shift"));
  }, []);

  const fetchShift = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}shift-master`);
      SetApiStatus(response?.status);
      const data = response?.data?.data;
      setShift(data);
    } catch (error) {
      console.error("Error fetching shifts:", error);
    }
  };

  useEffect(() => {
    fetchShift();
  }, []);

  const fetchOptShift = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}shift-master/create`);

      const weekdays = response?.data?.data?.daysofWeek;
      const weekopt = weekdays.map((comp) => ({
        value: comp.value,
        label: comp.text,
      }));
      setweekdays(weekopt);
      const weekshift = response?.data?.data?.OnWeekofMonth;
      const shiftopt = weekshift.map((comp) => ({
        value: comp.value,
        label: comp.text,
      }));
      setWeekshift(shiftopt);
      const status = response?.data?.data?.Status;
      const statusopt = status.map((comp) => ({
        value: comp.value,
        label: comp.text,
      }));
      setStatus(statusopt);
    } catch (error) {
      console.error("Error fetching shifts:", error);
    }
  };

  useEffect(() => {
    fetchOptShift();
  }, []);

const handleTimeChange = (name, timeInSeconds) => {
    const hours = String(Math.floor(timeInSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((timeInSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const formattedTime = `${hours}:${minutes}:00`;

    // Create a temporary updated form data to validate
    const tempFormData = { ...formData, [name]: formattedTime };

    // Validate FromTime < ToTime
    if (tempFormData.FromTime && tempFormData.ToTime) {
      const fromTime = new Date(`2000-01-01T${tempFormData.FromTime}`);
      const toTime = new Date(`2000-01-01T${tempFormData.ToTime}`);
      
      if (fromTime >= toTime) {
        toast.error("From Time must be earlier than To Time");
        return; // Don't update the state if validation fails
      }
    }

    // Update the time field (only reaches here if validation passes)
    const updatedFormData = { ...formData, [name]: formattedTime };

    // Calculate working hours if both times are available
    if (
      (name === "FromTime" || name === "ToTime") &&
      updatedFormData.FromTime &&
      updatedFormData.ToTime
    ) {
      const workingHours = calculateWorkingHours(
        updatedFormData.FromTime,
        updatedFormData.ToTime
      );
      updatedFormData.Hrs = workingHours;
    }

    setFormData(updatedFormData);
};

  const handleEdit = async (id) => {
    setShowModal(true);
    setIsEditMode(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}shift-master/${id.ID}`
      );

      if (response.status === 200) {
        const shiftData = response?.data?.data?.shift;
        const shiftWeeks = response?.data?.data?.shiftWeeks;

        if (shiftData && shiftWeeks.length > 0) {
          const { Name, Code, Description, FromTime, ToTime, Hrs } = shiftData;
          const { Day_046, AttendanceStatusID } = shiftWeeks[0];
          const Week_049 = shiftWeeks[0].Week_049;

          // Update lines array with correct ShiftID
          const updatedLines = shiftWeeks.map((week) => ({
            ID: id.ID,
            LineNo: 1,
            Day_046: week.Day_046 || "",
            Week_049: week.Week_049 || "",
            AttendanceStatusID: week.AttendanceStatusID || "",
          }));

          // Set form data with appropriate values
          setFormData({
            id: id.ID,
            Name: Name || "",
            Code: Code || "",
            Description: Description || "",
            FromTime: FromTime || "",
            ToTime: ToTime || "",
            Hrs: Hrs || "12",
            lines: updatedLines,
          });
        } else {
          console.error("Shift data or shift week not found with ID:", id);
        }
      } else {
        console.error(
          "Failed to fetch shift details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching shift details:", error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });

    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const resetFormState = () => {
    setFormData({
      Name: "",
      Code: "",
      Description: "",
      FromTime: "07:00:00",
      ToTime: "19:00:00",
      Hrs: "12",
      lines: [
        {
          ShiftID: "",
          LineNo: 1,
          Day_046: "",
          Week_049: "",
          AttendanceStatusID: "",
        },
      ],
    });
    setIsEditMode(false); // Reset edit mode state
  };

  const validateForm = () => {
    const newErrors = {
      ...errors,
      Name: !formData.Name ? "Name is required" : "",
      Code: !formData.Code ? "Code is required" : "",
    };

    // Validate each line
    const lineErrors = formData.lines.map((line, index) => {
      const lineError = {
        Day_046: !line.Day_046 ? "Day is required" : "",
      };
      return lineError;
    });

    newErrors.lines = lineErrors;
    setErrors(newErrors);

    // Check if any errors exist
    const hasErrors = Object.values(newErrors).some((error) =>
      typeof error === "string"
        ? error
        : Object.values(error).some((lineError) =>
            Object.values(lineError).some((e) => e)
          )
    );

    return !hasErrors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      const method = isEditMode ? "put" : "post";
      const apiUrl = isEditMode
        ? `${API_URL}shift-master/${formData.id}`
        : `${API_URL}shift-master`;
      try {
        const response = await PostServiceCaller(apiUrl, formData, method);
        if (method === "post") {
          toast.success("Shift Details submitted successfully!");
        } else {
          toast.success("Shift Details updated successfully!");
        }
        resetFormState();
        fetchShift();
        setIsEditMode(false);
        setShowModal(false);
      } catch (error) {
        console.error("There was an error submitting the form data!", error);
        toast.error("Error submitting form data.");
      }
    }
  };

  const handleEditModalClose = () => {
    setShowModal(false);
    resetFormState();
  };

  const handleChanged = (value, rowIndex, field) => {
    const updatedLines = [...formData.lines];
    updatedLines[rowIndex][field] = value;
    setFormData({ ...formData, lines: updatedLines });
  };

  const deleteRow = async (index) => {
    try {
      const lineToDelete = formData.lines[index];
      const response = await PostServiceCaller(
        `${API_URL}shift-master/${lineToDelete.ID}`,
        formData,
        "delete"
      );

      if (response.status === 200) {
        const updatedLines = formData.lines.filter((_, i) => i !== index);
        setFormData((prevState) => ({
          ...prevState,
          lines: updatedLines,
        }));
        toast.success("Row Level Data deleted successfully!");
      } else {
        throw new Error("Failed to delete the line");
      }
    } catch (error) {
      console.error("There was a problem with the delete operation:", error);
    }
  };

  const addRow = () => {
    const currentRow = formData.lines[formData.lines.length - 1];
    if (
      !currentRow.Day_046 ||
      !currentRow.Week_049 ||
      !currentRow.AttendanceStatusID
    ) {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    const newLine = {
      ShiftID: "",
      LineNo: formData.lines.length === 0 ? 1 : formData.lines.length + 1,
      Day_046: "",
      Week_049: "",
      AttendanceStatusID: "",
    };

    setFormData((prevState) => ({
      ...prevState,
      lines: [...prevState.lines, newLine],
    }));
  };

  const handleAddForm = () => {
    resetFormState();
    setShowModal(true);
  };
  const calculateWorkingHours = (fromTime, toTime) => {
    if (!fromTime || !toTime) return 0;

    // Parse times (format: "HH:mm:ss")
    const fromParts = fromTime.split(":");
    const toParts = toTime.split(":");

    const fromHours = parseInt(fromParts[0]);
    const fromMinutes = parseInt(fromParts[1]);
    const toHours = parseInt(toParts[0]);
    const toMinutes = parseInt(toParts[1]);

    // Calculate total minutes
    const fromTotal = fromHours * 60 + fromMinutes;
    const toTotal = toHours * 60 + toMinutes;

    // Calculate difference in hours (with decimal for minutes)
    const diffHours = (toTotal - fromTotal) / 60;

    // Return with 2 decimal places, ensuring positive value
    return Math.max(0, parseFloat(diffHours));
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={Shift}
              columns={columns}
              itemsPerPage={8}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isAddNewBtnRequired={true}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isSorting={true}
              isActionRequired={true}
              handleIcon1={handleEdit}
              handleAddNew={handleAddForm}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
              }}
            />
          </div>
        </div>
        {/* Bootstrap Modal */}
        {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div
              className="modal-dialog modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content">
                <div
                  className="modal-header d-flex justify-content-between"
                  style={{
                    display: "flex",

                    justifyContent: "space-between",

                    alignItems: "center",

                    borderBottom: "1px solid #f0f0f0",

                    backgroundColor: "#f8f9fa",

                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <p
                    style={{
                      fontSize: "20px",

                      fontWeight: "600",

                      color: "#27568B",

                      margin: "0",
                    }}
                  >
                    {isEditMode ? "Edit Shift" : "Add Shift"}
                  </p>
                  <span className="me-2">
                    <i
                      className="bi bi-x-lg"
                      onClick={handleEditModalClose}
                    ></i>
                  </span>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Code<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.Code ? "is-invalid" : ""
                            }`}
                            id="Code"
                            aria-describedby="Code"
                            name="Code"
                            placeholder="Code"
                            value={formData.Code}
                            onChange={handleInputChange}
                          />
                          {errors.Code && (
                            <div className="invalid-feedback">
                              {errors.Code}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Name<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.Name ? "is-invalid" : ""
                            }`}
                            id="Name"
                            aria-describedby="Name"
                            name="Name"
                            placeholder="Name"
                            value={formData.Name}
                            onChange={handleInputChange}
                          />
                          {errors.Name && (
                            <div className="invalid-feedback">
                              {errors.Name}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Description
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="Description"
                            aria-describedby="Description"
                            name="Description"
                            placeholder="Description"
                            value={formData.Description}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            From Time<span className="required">*</span>
                          </label>
                          <TimePicker
                            value={
                              formData.FromTime
                                ? parseInt(formData.FromTime.split(":")[0]) *
                                    3600 +
                                  parseInt(formData.FromTime.split(":")[1]) * 60
                                : 7 * 3600
                            }
                            start="07:00"
                            end="23:00"
                            step={30}
                            onChange={(time) =>
                              handleTimeChange("FromTime", time)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            To Time<span className="required">*</span>
                          </label>
                          <TimePicker
                            value={
                              formData.ToTime
                                ? parseInt(formData.ToTime.split(":")[0]) *
                                    3600 +
                                  parseInt(formData.ToTime.split(":")[1]) * 60
                                : 19 * 3600
                            }
                            start="07:00"
                            end="23:00"
                            step={30}
                            onChange={(time) =>
                              handleTimeChange("ToTime", time)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Working Hrs
                          </label>
                          <input
                            type="text"
                            class="form-control text-end"
                            id="Hrs"
                            aria-describedby="Hrs"
                            name="Hrs"
                            placeholder="Hrs"
                            value={formData.Hrs}
                            onChange={handleInputChange}
                            disabled
                          />
                        </div>
                      </div>

                      {/* shift details */}
                    </div>
                    <div className="text-end">
                      <button
                        type="button"
                        className="custom-btn-sm mb-2"
                        onClick={addRow}
                      >
                        Add Row
                      </button>
                    </div>
                    <div className="row px-2">
                      <table
                        id="poctable_head"
                        className="rounded table table-bordered"
                      >
                        <thead className="text-center">
                          <tr className="head">
                            <th>Sr. No.</th>
                            <th>
                              Days<span className="required">*</span>
                            </th>
                            <th>Weeks</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.lines.map((line, index) => (
                            <tr key={index}>
                              <td className="text-center">{index + 1}</td>
                              <td>
                                <div className="mb-3">
                                  <Select
                                    options={weekdays}
                                    value={weekdays.find(
                                      (opt) => opt.value === line.Day_046
                                    )}
                                    onChange={(selectedOption) => {
                                      handleChanged(
                                        selectedOption.value,
                                        index,
                                        "Day_046"
                                      );

                                      // Clear the error when a value is selected
                                      setErrors((prev) => {
                                        const newErrors = { ...prev };
                                        if (
                                          newErrors.lines &&
                                          newErrors.lines[index]
                                        ) {
                                          newErrors.lines[index].Day_046 = "";
                                        }
                                        return newErrors;
                                      });
                                    }}
                                    classNamePrefix="react-select"
                                    className={
                                      errors.lines?.[index]?.Day_046
                                        ? "is-invalid"
                                        : ""
                                    }
                                  />
                                  {errors.lines?.[index]?.Day_046 && (
                                    <div
                                      className="invalid-feedback"
                                      style={{ display: "block" }}
                                    >
                                      {errors.lines[index].Day_046}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>
                                <Select
                                  options={weekShift}
                                  value={weekShift.find(
                                    (opt) => opt.value === line.Week_049
                                  )}
                                  onChange={(selectedOption) =>
                                    handleChanged(
                                      selectedOption.value,
                                      index,
                                      "Week_049"
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Select
                                  options={status}
                                  value={status.find(
                                    (opt) =>
                                      opt.value === line.AttendanceStatusID
                                  )}
                                  onChange={(selectedOption) =>
                                    handleChanged(
                                      selectedOption.value,
                                      index,
                                      "AttendanceStatusID"
                                    )
                                  }
                                />
                              </td>
                              <td className="text-center">
                                <div
                                  className="poc_delectbtn"
                                  onClick={() => {
                                    if (!line?.ID) {
                                      setRowToDeleteIndex(index);
                                      setShowDeleteModal(true);
                                    }
                                  }}
                                >
                                  <i
                                    className={`fa fa-trash-o ${
                                      line?.ID ? "disabled-icon" : ""
                                    }`}
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="cancel-btn"
                      onClick={handleEditModalClose}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="custom-btn">
                     Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
      <Modal
        show={showDeleteModal}
        size="md"
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <div
          className="card rounded-3 border-0"
          style={{
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            border: "none",
            overflow: "hidden",
          }}
        >
          <Modal.Header
            className="border-0 pb-0"
            style={{ backgroundColor: "#f8fafc" }}
          >
            <Modal.Title className="w-100 text-center">
              <div className="d-flex flex-column align-items-center">
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    backgroundColor: "#fee2e2",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "12px",
                    color: "#dc2626",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <i
                    className="bi bi-exclamation-triangle-fill"
                    style={{ fontSize: "22px" }}
                  ></i>
                </div>
                <h3
                  className="m-0"
                  style={{
                    fontWeight: "600",
                    color: "#2E2E48",
                    fontSize: "1.25rem",
                  }}
                >
                  Delete Confirmation
                </h3>
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body
            className="text-center py-4"
            style={{
              backgroundColor: "#ffffff",
              color: "#64748b",
              fontSize: "0.9375rem",
              lineHeight: "1.5",
            }}
          >
            Are you sure you want to delete this item? This action cannot be
            undone.
          </Modal.Body>

          <Modal.Footer
            className="border-0 pt-0"
            style={{ backgroundColor: "#ffffff" }}
          >
            <div className="d-flex justify-content-center w-100 gap-3">
              <button
                style={{
                  backgroundColor: "#f3f4f6",
                  border: "1px solid #e5e7eb",
                  padding: "6px 18px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  color: "#374151",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                }}
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                style={{
                  backgroundColor: "#dc2626",
                  border: "none",
                  padding: "6px 18px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  color: "#ffffff",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                }}
                onClick={async () => {
                  if (rowToDeleteIndex !== null) {
                    await deleteRow(rowToDeleteIndex);
                    setRowToDeleteIndex(null);
                    setShowDeleteModal(false);
                  }
                }}
              >
                Delete
              </button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default Shift;
